<template>
    <div class="activity-linegraph">
        <div v-if="loading" class="activity-linegraph__overlay">
            <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Laster...</span>
            </div>
        </div>

        <div class="activity-linegraph__filters">
            <label v-for="group of itemGroups" :key="group.id" class="activity-linegraph__filter">
                <input
                    type="checkbox"
                    :value="group.id"
                    v-model="selectedGroupIds"
                    @change="fetchActivity"
                >
                {{ group.name }}
            </label>
        </div>

        <div class="activity-linegraph__filters">
            <label v-for="year of availableYears" :key="year" class="activity-linegraph__filter">
                <input type="checkbox" :value="year" v-model="selectedYears">
                {{ year }}
            </label>

            <button type="button" class="activity-linegraph__years-btn" @click="toggleYears">
                {{ allYearsSelected ? 'Velg ingen' : 'Velg alle' }}
            </button>
        </div>

        <h2>Ukentlige registreringer</h2>
        <p class="text-muted">Grafen viser antall registreringer i plukkegruppene per uke.</p>
        <highcharts :options="chartOptions" :highcharts="Highcharts"></highcharts>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import Highcharts from '../../highcharts';

export default {
    components: {
        highcharts: Chart,
    },
    created() {
        this.Highcharts = Highcharts;
    },
    data() {
        return {
            series: [],
            itemGroups: [],
            selectedGroupIds: [],
            selectedYears: [],
            loading: true,
        };
    },
    computed: {
        availableYears() {
            return this.series.map(s => s.year);
        },
        allYearsSelected() {
            return this.availableYears.length > 0 && this.selectedYears.length === this.availableYears.length;
        },
        chartOptions() {
            return {
                chart: {
                    type: 'line',
                },
                title: {
                    text: null,
                },
                xAxis: {
                    title: { text: 'Uke' },
                    type: 'linear',
                    allowDecimals: false,
                    tickInterval: 1,
                },
                yAxis: {
                    title: { text: 'Antall registreringer' },
                    min: 0,
                },
                series: this.series
                    .filter(s => this.selectedYears.includes(s.year))
                    .map(s => {
                        const trimmed = this.trimLeadingTrailingZeros(s.data);

                        return {
                            name: String(s.year),
                            data: trimmed.map(d => [d.week, d.count]),
                        };
                    }),
                credits: {
                    enabled: false,
                },
            };
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.loading = true;
            await this.fetchItemGroups();
            this.selectedGroupIds = this.itemGroups.map(group => group.id);
            await this.fetchActivity();
        },
        async fetchItemGroups() {
            try {
                const response = await fetch('/fetch/itemgroups');
                this.itemGroups = await response.json();
            } catch (error) {
                console.error(error);
            }
        },
        async fetchActivity() {
            if (this.selectedGroupIds.length === 0) {
                this.series = [];
                this.selectedYears = [];
                this.loading = false;
                return;
            }

            this.loading = true;

            try {
                const params = new URLSearchParams();
                this.selectedGroupIds.forEach(id => params.append('item_group_ids[]', id));

                const response = await fetch(`/api/v1/statistics/activity?${params.toString()}`);
                this.series = await response.json();
                this.selectedYears = this.series.map(s => s.year);
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        toggleYears() {
            this.selectedYears = this.allYearsSelected ? [] : [...this.availableYears];
        },
        trimLeadingTrailingZeros(data) {
            let start = 0;
            let end = data.length - 1;

            while (start <= end && data[start].count === 0) {
                start++;
            }

            while (end >= start && data[end].count === 0) {
                end--;
            }

            return data.slice(start, end + 1);
        },
    },
};
</script>
<style scoped>
.activity-linegraph {
    position: relative;
}

.activity-linegraph__overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.7);
}

.activity-linegraph__filters {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
}

.activity-linegraph__filter {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    cursor: pointer;
}

.activity-linegraph__years-btn {
    background: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0.1rem 0.6rem;
    cursor: pointer;
}

</style>
